import React, { useEffect, useState } from "react";
import i18next from "i18next";
import {
  optionsCallToActionAppPromotionMeta,
  optionsCallToActionAwarenessMeta,
  optionsCallToActionEngagementMeta,
  optionsCallToActionEngagementMetaPost,
  optionsCallToActionLeadsInstantFormMeta,
  optionsCallToActionLeadsMeta,
  optionsCallToActionSalesMeta,
  optionsCallToActionTrafficMeta,
} from "../../../../utils/options";
import {
  ADS_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM_META_VALUE,
  ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE,
  ADS_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE_META_VALUE,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
} from "../../../../utils/constants";
import {
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE,
  FIELD_REQUIRED,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import Select from "../../../Form/Select";
import { useController, useFormContext } from "react-hook-form";

const getAdditionalCallToActions = ({ objective, destinationType }) => {
  if (
    (objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION ||
      objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION) &&
    destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION
  ) {
    return [
      {
        value: ADS_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE_META_VALUE,
        label: ADS_CAMPAIGN_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE,
      },
    ];
  }
  if (
    (objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION ||
      objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION) &&
    destinationType ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION
  ) {
    return [
      {
        value: ADS_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM_META_VALUE,
        label: ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM,
      },
    ];
  }
  if (
    (objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION ||
      objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION) &&
    (destinationType ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION ||
      destinationType ===
        ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION)
  ) {
    return [
      {
        value: ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE,
        label: ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE,
      },
    ];
  }
  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION &&
    destinationType ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION
  ) {
    return [
      {
        value: ADS_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM_META_VALUE,
        label: ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM,
      },
    ];
  }
  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION &&
    destinationType ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION
  ) {
    return [
      {
        value: ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE,
        label: ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE,
      },
    ];
  }
  return [];
};

const SelectCallToActionMeta = React.forwardRef(
  function SelectCallToActionMeta(props, ref) {
    const {
      control,
      errors,
      rules = {
        required: {
          value: true,
          message: i18next.t(FIELD_REQUIRED),
        },
      },
      name,
      label,
      disabled,
      platform,
      destinationType = ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
      fullWidth,
      variant = "filled",
      objective,
      sx = {},
      disabledOptions = [],
      excludeOptions = [],
      required = true,
    } = props;

    const [options, setOptions] = useState([]);
    const { t } = useTranslationApp();

    const { setValue } = useFormContext();
    const {
      field: { value: fieldValue },
    } = useController({
      control,
      name,
    });

    useEffect(() => {
      if (!objective) return;

      const isDestinationTypeInstantForm =
        destinationType ===
        ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION;

      const additionalCallToActions = getAdditionalCallToActions({
        platform,
        objective,
        destinationType,
      });

      let baseOptions = [];
      if (objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION)
        baseOptions = optionsCallToActionAwarenessMeta.concat(
          additionalCallToActions
        );
      if (objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION)
        baseOptions = optionsCallToActionTrafficMeta.concat(
          additionalCallToActions
        );
      if (objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION) {
        if (
          destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION
        ) {
          baseOptions = optionsCallToActionEngagementMetaPost;
        } else {
          baseOptions = optionsCallToActionEngagementMeta.concat(
            additionalCallToActions
          );
        }
      }
      if (objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION) {
        if (
          destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION
        ) {
          baseOptions = [
            {
              value: ADS_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE_META_VALUE,
              label: ADS_CAMPAIGN_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE,
            },
          ];
        } else if (isDestinationTypeInstantForm) {
          baseOptions = optionsCallToActionLeadsInstantFormMeta.concat(
            additionalCallToActions
          );
        } else {
          baseOptions = optionsCallToActionLeadsMeta.concat(
            additionalCallToActions
          );
        }
      }
      if (objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION)
        baseOptions = optionsCallToActionAppPromotionMeta;
      if (objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION)
        baseOptions = optionsCallToActionSalesMeta.concat(
          additionalCallToActions
        );

      const filteredOptions = excludeOptions?.length
        ? baseOptions.filter((o) => !excludeOptions.includes(o.value))
        : baseOptions;
      setOptions(filteredOptions);
    }, [objective, platform, destinationType, excludeOptions]);

    useEffect(() => {
      if (options?.length === 0) return;

      if (!fieldValue) {
        if (!required) return;
        const firstAvailable = options.find(
          (o) => !disabledOptions.includes(o.value)
        );
        if (firstAvailable) {
          setValue(name, firstAvailable.value, { shouldDirty: false });
        }
        return;
      }
      const isValidCallToAction = options.some((o) => o.value === fieldValue);
      const isDisabled = disabledOptions.includes(fieldValue);
      if (!isValidCallToAction || isDisabled) {
        const firstAvailable = options.find(
          (o) => !disabledOptions.includes(o.value)
        );
        if (firstAvailable) {
          setValue(name, firstAvailable.value, { shouldDirty: false });
        } else if (!required) {
          setValue(name, "", { shouldDirty: false });
        }
      }
      // eslint-disable-next-line
    }, [fieldValue, options, required, disabledOptions]);

    const optionsWithDisabled = options.map((opt) => ({
      ...opt,
      disabled: disabledOptions.includes(opt.value),
    }));

    return (
      <Select
        ref={ref}
        label={t(label)}
        disabled={disabled}
        name={name}
        variant={variant}
        options={optionsWithDisabled}
        fullWidth={fullWidth}
        doTranslate={true}
        control={control}
        errors={errors}
        rules={
          required
            ? {
                ...rules,
                validate: (value) => {
                  if (!options.map((o) => o.value).includes(value))
                    return t(FIELD_REQUIRED);
                },
              }
            : { required: false }
        }
        showEmptyOption={!required}
        sx={sx}
      />
    );
  }
);

export default SelectCallToActionMeta;
